export default function dataURLtoFile(dataurl) {
    const arr = dataurl.split(',')
    const mimeMatch = arr[0].match(/:(.*?);/)
    const mime = mimeMatch ? mimeMatch[1] : 'image/png'

    const mimeToExt = {
        'image/webp': 'webp',
        'image/png': 'png',
        'image/jpeg': 'jpg',
    }
    const ext = mimeToExt[mime] || 'png'

    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    return new File([u8arr], `signature.${ext}`, { type: mime })
}